export const getProgress = (task) => {
  if (!task.checklist?.length) return 0;
  const completed = task.checklist.filter(item => item.completed).length;
  return (completed / task.checklist.length) * 100;
}; 